// extracted by mini-css-extract-plugin
export var center = "_5q-2";
export var clickableRow = "_5q-5";
export var expandedRow = "_5q-7";
export var hoverable = "_5q-4";
export var left = "_5q-1";
export var right = "_5q-3";
export var row = "_5q-0";
export var selectedRow = "_5q-6";
export var summaryRow = "_5q-8";